// Vuex store
//
// - `auth`        — @emcd-shared/auth-service/store
// - `coinService` — @emcd-shared/coin-service,
//
// Populated via `loadCoinServiceBalance()` in src/api/coinService.js.
import { createStore } from "vuex";
import auth from "@emcd-shared/auth-service/store";
import coinService from "@emcd-shared/coin-service";

const store = createStore({
  modules: {
    auth,
    coinService,
  },
});

// Снимок чистого состояния сразу после создания стора
// Модули из @emcd-shared не имеют reset-мутаций
const pristineState = JSON.parse(JSON.stringify(store.state));

export const resetStore = () => {
  store.replaceState(JSON.parse(JSON.stringify(pristineState)));
};

export default store;
